
import Vue from "vue";

export default Vue.extend({
	props: {
		color: String,
		className: String,
		backgroundColor: String,
		borderRadius: String,
		float: String,
	},
	methods: {
		onClick(event: Event) {
			this.$emit("click", event);
		}
	}
});
